import { useContext, useEffect,useState } from 'react';
import {
  Box, Drawer, Toolbar, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Icon, Tooltip
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../stores/hooks';
import { setcurrentmenu } from '../stores/menuslice';
import { Menu } from '../data/interfaces/sharedmodels';
import userService from '../data/api/user.service';
import { IsEditedContext } from '../../App';
import ConfirmDialog from '../shared/confirmdialog';


export default function ClippedDrawer() {
  const [menus, setMenus] = useState<Menu[]>([]);
  const dispatch = useAppDispatch();
  const isMenuOpen = useAppSelector((state) => state.menuReducer.isMenuOpen);
  const selectedmenu = useAppSelector((state) => state.menuReducer.currentMenu);
  const isAUthapiReady = useAppSelector((state) => state.authReducer.AuthApiReady);
  const isAuthenticated = useAppSelector((state) => state.authReducer.IsAuthenticated);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [pendingMenuItem, setPendingTable] = useState<string | null>(null);
  
  const {isEdited, setIsEdited} = useContext(IsEditedContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    //if(isAuthenticated){
    userService.getusermenu().then((response)=>{
      setMenus(response.data);
    })
    .catch((error)=>{
      
    });
  
  //}
  }, []);

  const handleMenuClick = ( event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,menu: string) => {
    if (isEdited) {
           event.preventDefault();
      setConfirmDialogOpen(true); 
      setPendingTable(menu); 
    } else {
      dispatch(setcurrentmenu(menu));
    }
   
  };

  const handleDialogCallback = (confirmed: boolean) => {
    setConfirmDialogOpen(false);
   
    if (!confirmed && pendingMenuItem) {
        setIsEdited(false);
        
        dispatch(setcurrentmenu(pendingMenuItem));
        navigate('/'+pendingMenuItem);
    }
    setPendingTable(null); 
  };

  return ( 
   
    <Drawer
      variant="permanent"
      open={isMenuOpen}
    >
     <ConfirmDialog
        isopen={confirmDialogOpen}
        title="Unsaved Changes"
        message="Are you sure you want to continue? Any unsaved changes will be lost."
        needComments={false}
        callback={handleDialogCallback}
        yesButtonText="Stay and Save"
        cancelButtonText="Continue"
      />
      <Toolbar />
      <Box sx={{ overflow: 'auto' }} >
        <List>
          {menus.map((menu, index) => (
            <Tooltip key={menu.Name}  title={menu.Description} placement="right" arrow>
            <ListItem aria-label={menu.Description} disablePadding sx={{ display: 'block', bgcolor: selectedmenu === menu.Name ? 'primary.main' : 'secondary.main' }} >
              <ListItemButton component={RouterLink} to={'/' + menu.Name} selected={selectedmenu === menu.Name} onClick={(event) => handleMenuClick(event, menu.Name)} sx={{
                minHeight: 48,
                justifyContent: isMenuOpen ? 'initial' : 'center',
                px: 2.5
              }}>
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: isMenuOpen ? 1 : 'auto',
                    justifyContent: 'center',
                    color: selectedmenu === menu.Name ? 'secondary.main' : 'primary.main'
                  }}>
                  <Icon>{menu.Icon}</Icon>
                </ListItemIcon>
                <ListItemText primary={menu.Description} sx={{ display: isMenuOpen ? 'block' : 'none', color: selectedmenu === menu.Name ? 'secondary.main' : 'primary.main', pr: 6 }} />
              </ListItemButton>
            </ListItem>
            </Tooltip>
          ))}
        </List>
      </Box>
    </Drawer>
  
  );
}